module.exports = __webpack_public_path__ + "static/fonts/open-sans-bold.1f85e92.woff";